export const CATEGORY_MASTER_ACTION = 'CATEGORY_MASTER_ACTION';
export const CATEGORY_MASTER_SUCCESS_ACTION = 'CATEGORY_MASTER_SUCCESS_ACTION';
export const CATEGORY_MASTER_FAILURE_ACTION = 'CATEGORY_MASTER_FAILURE_ACTION';
